import { StoreType } from "./components/types";
import { TRACKING_SCOPES } from "./constants";
import { FormValuesV2 } from "./utils";

export const defaultValues = {
  eventCategories: [] as string[],
  webhookCategories: [] as string[],
  iterableApiKey: "",
  productTracking: [] as string[],
  storeType: StoreType.TRADITIONAL,
};

export const defaultValuesV2: FormValuesV2 = {
  iterableApiKey: "",
  clientSideEvents: [],
  webhookTopics: [],
  catalogResyncing: false,
  catalogAccess: true,
  storeType: StoreType.TRADITIONAL,
  resyncCatalogFrom: "",
};

const formConfig = {
  clientSideEventChoices: [
    {
      label: "Product View",
      value: TRACKING_SCOPES.productView,
    },
    {
      label: "Login",
      value: TRACKING_SCOPES.login,
    },
    {
      label: "Logout",
      value: TRACKING_SCOPES.logout,
    },
  ],

  weebhookEventChoices: [
    {
      label: "Order",
      value: TRACKING_SCOPES.order,
    },
    {
      label: "Shipping",
      value: TRACKING_SCOPES.shipping,
    },
    {
      label: "Customer",
      value: TRACKING_SCOPES.customer,
    },
  ],

  productTrackingChoices: [
    {
      label: "Catalog",
      value: TRACKING_SCOPES.catalog,
    },
  ],
};

export default formConfig;
